import type { ProcedureRpcLinkCodecOptions } from "./codec.js";
import { ProcedureRpcLinkCodec } from "./codec.js";

/**
 * oRPC-style handler wrapper that composes codec internals behind a single interface.
 * Keeps route handlers focused on auth/dispatch concerns rather than wire-format details.
 */
export class ProcedureRpcHandler {
  private readonly codec: ProcedureRpcLinkCodec;

  constructor(options: ProcedureRpcLinkCodecOptions = {}) {
    const codec = new ProcedureRpcLinkCodec(options);
    this.codec = codec;
  }

  decodeProcedureRpcBody(body: unknown): { name: unknown; args: unknown } {
    return this.codec.decodeProcedureRpcBody(body);
  }

  decodeProcedureMultipart(form: FormData): { name: unknown; args: unknown } {
    return this.codec.decodeProcedureMultipart(form);
  }

  encodeWirePayload(value: unknown) {
    return this.codec.encodeWirePayload(value);
  }

  encodeProcedureCall(payload: { name: unknown; args: unknown }) {
    return this.codec.encodeProcedureCall(payload);
  }
}
